export default "__VITE_ASSET__Dt9AzPa8__"